<div class="modal-premium-container">
  <modal-default-mmaxapp>
    <div class="cart-merge-card">
      <div class="card-header">
        <div class="icon-circle">
          <i class="mdi mdi-cart-sync"></i>
        </div>
        <h2 class="card-title">Carrito de compras abierto detectado</h2>
      </div>

      <div class="card-body">
        <p class="card-description">
          Se detectó un carrito con productos de una sesión anterior.
          ¿Deseas conservarlos y combinarlos con tu selección actual o prefieres empezar de cero?
        </p>
      </div>

      <div class="card-actions">
        <button class="btn-secondary" (click)="descartarCarritoWeb()">
          <span>Descartar anterior</span>
        </button>
        <button class="btn-primary" (click)="combinarCarritos()">
          <span>Combinar carritos</span>
        </button>
      </div>
    </div>
  </modal-default-mmaxapp>
</div>